import { Type } from "class-transformer";
export class DocumentHandlerTaskStatus {
    name: string;
    arguments: string;
    configs: string[];
    isRunning = false;
    @Type(() => Date)
    nextRun: Date;
}
